import type { Formation, FormationDomaine, Tone } from '../types';
import { ImgPlaceholder } from './ImgPlaceholder';

const DOMAIN_TONE: Record<FormationDomaine, Tone> = {
  Implantologie: 'vert',
  Orthodontie: 'rouge',
  Endodontie: 'or',
  Parodontologie: 'vert',
  'Esthétique dentaire': 'rouge',
  'Chirurgie orale': 'or',
  Pédodontie: 'vert',
};

export function getDomainTone(domaine: FormationDomaine): Tone {
  return DOMAIN_TONE[domaine] ?? 'vert';
}

type Props = {
  f: Formation;
  onClick?: () => void;
  variant?: 'default' | 'compact';
};

// Maps the derived status tone onto an existing pill colour palette.
const STATUS_PILL: Record<'open' | 'soldout' | 'custom' | 'none', string> = {
  open: 'mtc-pill-vert',
  soldout: 'mtc-pill-warn',
  custom: 'mtc-pill-or',
  none: 'mtc-pill-neutral',
};

export function FormationCard({ f, onClick, variant = 'default' }: Props) {
  const tone = getDomainTone(f.domaine);
  const placeholderTone: Tone = tone === 'or' ? 'creme' : tone;
  const filling =
    f.statusTone === 'open' && f.placesRestantes > 0 && f.placesRestantes <= 4;
  const moduleCount = f.programme.length;

  return (
    <article
      className={`mtc-formation-card ${variant === 'compact' ? 'is-compact' : ''}`}
      onClick={onClick}
    >
      <div className="mtc-formation-card-img">
        <ImgPlaceholder
          label={`${f.image} · ${f.domaine}`}
          ratio="4/3"
          tone={placeholderTone}
          src={f.heroImage}
          alt={f.titre}
          fit="contain"
        />
        <div className="mtc-formation-card-overlay">
          <span className={`mtc-pill mtc-pill-${tone}`}>{f.domaine}</span>
          <span className={`mtc-pill ${STATUS_PILL[f.statusTone]}`}>{f.statusLabel}</span>
          {filling && <span className="mtc-pill mtc-pill-warn">Bientôt complet</span>}
        </div>
      </div>
      <div className="mtc-formation-card-body">
        <div className="mtc-formation-card-meta">
          <span>{f.moduleDatesShort}</span>
          <span className="mtc-dot">·</span>
          <span>{f.ville}</span>
        </div>
        <h3 className="mtc-formation-card-title">{f.titre}</h3>
        <p className="mtc-formation-card-acc">{f.accroche}</p>
        <div className="mtc-formation-card-foot">
          <div className="mtc-formation-card-price">
            <span className="num">{f.prixParModule.toLocaleString('fr-FR')}</span>
            <span className="unit">{f.devise} HT</span>
            <span className="unit ht-tag">/ module</span>
          </div>
          <div className="mtc-formation-card-extra">
            <span>
              {moduleCount} module{moduleCount > 1 ? 's' : ''}
            </span>
            <span className="mtc-dot">·</span>
            <span>{f.heures}h</span>
          </div>
        </div>
      </div>
    </article>
  );
}
